// @flow
import * as React from 'react';
import styled from 'styled-components';
import {type LocalizedText, LocalizedParagraph} from 'components/Localized';
import {Fade} from 'components/Animation';

type Props = {
  guide?: LocalizedText,
  guides?: Array<LocalizedText>,
  paddingBottom?: number,
};

export default function GuideMessage(props: Props): React.Element<any> {
  const {guide, ...others} = props;
  return (
    <Fade {...others}>
      <GuideText datapaddingbottom={props.paddingBottom}>
        <div>
          <Line />
        </div>
        {props.guide && <LocalizedParagraph {...props.guide} />}
        {props.guides && props.guides.map((value, index) => <LocalizedParagraph key={index} {...value} />)}
      </GuideText>
    </Fade>
  );
}

const GuideText = styled.div`
  text-align: left;
  text-align: start;
  flex-direction: column;
  padding-bottom: ${props => props.datapaddingbottom ?? 0}px;
  padding-left: ${(props) => (props.theme.layout.mobile ? 92 : 0)}px;
  padding-right: ${(props) => (props.theme.layout.mobile ? 92 : 0)}px;
`;

const Line = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 16 : 24)}px;
  height: ${(props) => (props.theme.layout.mobile ? 1 : 2)}px;
  background-color: #ffffff;
  margin-bottom: 16px;
`;
